import { PersonalizationReducerState } from "./types";
import { PersonalizationDataForm } from "../../requests/personalization/types";
import { PERSONALITION_FALLBACK_BOOLEAN } from "./constants";

export function transformPersonalizationData(
  personalizationData: PersonalizationReducerState
): PersonalizationDataForm {
  const { colors, ...rest } = personalizationData;
  return { ...colors, ...rest };
}

export const personalizationBooleanPriorityHelper = (
  serverData: boolean | undefined,
  userData: boolean | undefined
): boolean => {
  const isServerUndefined = typeof serverData === "undefined";
  const isUserUndefined = typeof userData === "undefined";

  // Nic neprislo = guard
  if (isServerUndefined && isUserUndefined)
    return PERSONALITION_FALLBACK_BOOLEAN;
  // admin neni, user je
  if (isServerUndefined && !isUserUndefined) return !!userData;
  // user neni, admin je
  if (isUserUndefined && !isServerUndefined) return !!serverData;
  // server data jsou, ale jsou false
  if (!isServerUndefined && !serverData) return !!serverData;
  // server data jsou a jsou true = rozhoduje user
  if (!isServerUndefined && !isUserUndefined && serverData) return !!userData;
  return PERSONALITION_FALLBACK_BOOLEAN;
};
